import { Injectable, Inject } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class CommonService {
  private notify = new Subject<any>();
  private notifyRev = new Subject<any>();
  /**
   * Observable string streams
   */
  notifyObservable$ = this.notify.asObservable();
  notifyObservableReverse$ = this.notifyRev.asObservable();

  constructor() {}

  public notifyOther(searchString) {
    if (searchString) {
      this.notify.next(searchString);
    }
  }

  public notifyNavbar(activeCurrentVal) {
    if (activeCurrentVal) {
      this.notifyRev.next(activeCurrentVal);
    }
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/navbar/searchCommon.service.ts